import { Dispatch } from 'redux';
import fetchApi from '../services/api';
import * as types from './actionTypes';
import { isInt } from '../lib/helpers';

/**
 * Fetch a random listing.
 * @param {number} maxPrice - The max price to fetch for
 * @param {string} state - The location to fetch for
 */
export function fetchRandomListingCount(maxPrice: number, state: string) {
  // As a default, use a price range for random listings of x * 0.8 <> x.
  // If a user has selected >3000000, then we will back into that minumum with a
  // 0.03 multiplier to show them anything between $3-100m.
  const multiplier = maxPrice === 100000000 ? 0.03 : 0.8;
  return (dispatch: Dispatch<any>) =>
    fetchApi(
      `/listing/random-count/${maxPrice}?state=${state}&multiplier=${multiplier}`,
    )
      .then(async response => {
        const json = await response.json();
        if (response.ok) {
          dispatch({
            count: parseInt(json.count, 10),
            location: state,
            maxPrice: parseInt(json.maxPrice, 10),
            type: types.RandomListingCountSuccess,
          });
        } else {
          dispatch({
            messages: [json],
            type: types.RandomListingCountFailure,
          });
        }
      })
      .catch(error => {
        dispatch({
          error,
          type: types.GenericError,
        });
      });
}

/**
 * Fetch the number of listings that match this price.
 * @param {number} maxPrice - The max price to fetch for
 * @param {number} count - How many listings to fetch
 * @param {string} state - location to fetch
 */
export function fetchRandomListing(
  maxPrice: number,
  count: number,
  state: string,
  token?: string,
  reset: boolean = false,
) {
  const multiplier = maxPrice === 100000000 ? 0.03 : 0.8;
  const countToUse = isInt(count) ? count : 10;
  return async (dispatch: Dispatch<any>) => {
    if (reset) {
      dispatch({
        type: types.ClearRandomListings,
      });
    }
    try {
      const response = await fetchApi(
        `/listing/random/${maxPrice}?state=${state}&multiplier=${multiplier}&count=${countToUse}&photos=photoLarge`,
        {},
        'get',
        {},
        token,
      );
      const json = await response.json();
      if (response.ok) {
        dispatch({
          listings: json.listings,
          type: types.RandomListingFetchSuccces,
        });
      } else {
        dispatch({
          messages: [json],
          type: types.RandomListingFetchFailure,
        });
      }
    } catch (error) {
      dispatch({
        error,
        type: types.GenericError,
      });
    }
  };
}

/**
 * Mark the page as visited for a user
 */
export function setVisited() {
  return (dispatch: Dispatch<any>) => {
    dispatch({
      type: 'VISITED_RANDOM_HOME',
    });
  };
}
